export enum UserRole {
  lead = 'Lead',
  portfolioManager = 'PortfolioManager',
  analyst = 'Analyst',
  trader = 'Trader',
  other = 'Other'
}
export interface User {
  userId: string;
  firstName: string;
  lastName: string;
  role: UserRole;
}

export interface SelectableUser extends User {
  selected: boolean;
}

export interface SelectableUsersByRole {
  role: UserRole;
  label: string;
  users: SelectableUser[];
}
